import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Job } from '~hooks/useJob/models';
import { Load } from '~hooks/useLoad/models';
import { Ticket } from '~hooks/useTickets/models';
import { getTicketMaterial } from '~utils/tickets/ticket-utils';

interface MaterialColumnProps {
  job: Job;
  load: Load;
  sx?: SxProps<Theme>;
  ticket?: Ticket;
}

export default function MaterialColumn({ job, load, sx, ticket }: MaterialColumnProps) {
  const material = getTicketMaterial(ticket, load, job)?.name ?? '-';

  return (
    <Box sx={sx}>
      <OverflowAwareText>{material}</OverflowAwareText>
    </Box>
  );
}
